/*doc

 Contains the list of authors a user follows.
 Store is populated with list of authors plus
 relevant data. Data is rendered in
 AskTheAuthorCommunityQuestionAnswerContainer

 */

import Reflux from "reflux";
import AskTheAuthorFollowedAuthorsActions from "../react_actions/ask_the_author/followed_authors_actions";
import Freezer from "freezer-js";
import { each } from "lodash";

const state = new Freezer({
  authors: [],
  total: 0,
});

let fullFollowedAuthorsList = [];

const DESKTOP_DEFAULT_INITIAL_LIST_SIZE = 3;
const DESKTOP_LOAD_MORE_SIZE = 3;

const MOBILE_DEFAULT_INITIAL_LIST_SIZE = 3;
const MOBILE_LOAD_MORE_SIZE = 3;

let defaultListSize;
let loadMoreSize;

export default Reflux.createStore({
  listenables: [AskTheAuthorFollowedAuthorsActions],

  fullFollowedAuthorsList,

  DESKTOP_DEFAULT_INITIAL_LIST_SIZE,
  DESKTOP_LOAD_MORE_SIZE,

  MOBILE_DEFAULT_INITIAL_LIST_SIZE,
  MOBILE_LOAD_MORE_SIZE,

  defaultListSize,
  loadMoreSize,

  init() {
    this.getState().set({ authors: [], total: 0 });
    fullFollowedAuthorsList = [];
    defaultListSize = DESKTOP_DEFAULT_INITIAL_LIST_SIZE;
    loadMoreSize = DESKTOP_LOAD_MORE_SIZE;
  },

  getState() {
    return state.get();
  },

  getInitialState() {
    return this.getState();
  },

  reset() {
    this.getState().reset({});
    fullFollowedAuthorsList = [];
  },

  setMobileDefaults() {
    defaultListSize = MOBILE_DEFAULT_INITIAL_LIST_SIZE;
    loadMoreSize = MOBILE_LOAD_MORE_SIZE;
  },

  populateList(data) {
    const numFollowedAuthors = data.length;
    each(data, (singleAuthorData) => {
      fullFollowedAuthorsList.push({ name : singleAuthorData.author.name,
                                     id : singleAuthorData.author.id,
                                     profileUrl :singleAuthorData.author.profileUrl,
                                     profileImage : singleAuthorData.author.profileImage,
                                     authorTagline : singleAuthorData.authorTagline,
                                     questionURL : singleAuthorData.questionURL,
                                     answerURL : singleAuthorData.answerURL,
                                     answersCount : singleAuthorData.answersCount,
                                     ATAenabled : singleAuthorData.ATAenabled,
                                     recentQuestionText : singleAuthorData.answerData.recentQuestion.text,
                                     recentAnswerTruncatedHtml : singleAuthorData.answerData.recentAnswer.text,
                                     recentQuestionSpoiler : singleAuthorData.answerData.recentQuestion.spoiler,
                                     recentAnswerSpoiler : singleAuthorData.answerData.recentAnswer.spoiler,
                                     flagForAbuseUrl : singleAuthorData.answerData.flagForAbuseUrl,
                                     social : singleAuthorData.answerData.social });
    });
    if (numFollowedAuthors){
      let authors_list = fullFollowedAuthorsList;
      if (numFollowedAuthors > defaultListSize){
        authors_list = authors_list.slice(0, defaultListSize);
      }
      this.getState().set({ authors: authors_list, total: numFollowedAuthors });
    }
  },

  /*
  loads the next three authors from fullFollowedAuthorsList
  that were not previously loaded into the state authors variable
   */
  onLoadMoreFollowedAuthors(){
    const state = this.getState();
    let authorList = state.authors;
    const authorListLength = authorList.length;
    const totalAuthors = state.total;
    const toAdd = Math.min(loadMoreSize, (totalAuthors-authorListLength));
    for (let i=authorListLength; i<(authorListLength+toAdd); i++){
      const anotherAuthor = fullFollowedAuthorsList[i];
      authorList = authorList.push(anotherAuthor);
    }
    this.getState().set({ authors: authorList });
    this.trigger(this.getState());
  },
});
